import { useState } from 'react'

type Row = Record<string, unknown>

export function JsonView({ row, fullscreen }: { row: Row; fullscreen?: boolean }) {
  const json = JSON.stringify(row, null, 2)
  const [copied, setCopied] = useState(false)
  const highlighted = json
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, m => {
      if (/^"/.test(m)) return `<span class="${/:$/.test(m) ? 'jk' : 'js'}">${m}</span>`
      if (/true|false/.test(m)) return `<span class="jb">${m}</span>`
      if (m === 'null') return `<span class="jn">${m}</span>`
      return `<span class="jd">${m}</span>`
    })
  return (
    <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', position: 'relative' }}>
      <button
        className="btn btn-ghost btn-mono"
        style={{ position: 'absolute', top: 8, right: 12, fontSize: 10, padding: '2px 8px', zIndex: 1 }}
        onClick={() => { navigator.clipboard.writeText(json); setCopied(true); setTimeout(() => setCopied(false), 2000) }}
      >{copied ? '✓ copied' : 'copy'}</button>
      <pre className="mono" style={{ flex: 1, overflow: 'auto', margin: 0, padding: fullscreen ? '24px 10%' : '14px 16px', fontSize: 12, lineHeight: 1.7, maxWidth: fullscreen ? 1100 : undefined }}
        dangerouslySetInnerHTML={{ __html: highlighted }} />
    </div>
  )
}
